"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _iterables = require("rich-text-lib/utils/iterables");

var _ListMenu = _interopRequireDefault(require("rich-text-lib/components/formatting/ListMenu"));

var TinyMceListMenu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceListMenu, _Component);

  function TinyMceListMenu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceListMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceListMenu).call(this, props));
    _this.state = {
      isActive: false,
      listStyleType: props.defaultValue
    };
    _this.handleNodeChange = _this.handleNodeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TinyMceListMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = this.props.editor;
      editor.on('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editor = this.props.editor;
      editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.props.onClick(this.state.listStyleType);
    }
  }, {
    key: "handleNodeChange",
    value: function handleNodeChange(_ref) {
      var parents = _ref.parents,
          selectionChange = _ref.selectionChange;

      if (!parents) {
        return;
      }

      var _this$props = this.props,
          editor = _this$props.editor,
          nodeName = _this$props.nodeName,
          indentControlHandler = _this$props.indentControlHandler,
          defaultValue = _this$props.defaultValue;

      if (selectionChange) {
        indentControlHandler(editor);
      }

      var parentNode = parents.find(function (parent) {
        return parent.nodeName === nodeName;
      });

      if (parentNode) {
        var listStyleType = editor.dom.getStyle(parentNode, 'listStyleType') || defaultValue;
        this.setState({
          isActive: true,
          listStyleType: listStyleType
        });
      } else {
        this.setState({
          isActive: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var listMenuProps = (0, _iterables.omit)(Object.keys(TinyMceListMenu.propTypes), this.props);
      return _react.default.createElement(_ListMenu.default, (0, _extends2.default)({
        dropdownClassName: "mce-hubspot-menu",
        active: !!this.state.isActive,
        value: this.state.listStyleType,
        onClick: this.handleClick
      }, listMenuProps));
    }
  }]);
  return TinyMceListMenu;
}(_react.Component);

exports.default = TinyMceListMenu;
TinyMceListMenu.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  nodeName: _react.PropTypes.string.isRequired,
  defaultValue: _react.PropTypes.string.isRequired,
  indentControlHandler: _react.PropTypes.func.isRequired,
  onClick: _react.PropTypes.func.isRequired
};
module.exports = exports.default;